import { Tooltip } from "antd";
import GrillIcon from "shared-components/Components/CustomIcons/GrillIcon/web";
import PoolIcon from "shared-components/Components/CustomIcons/PoolIcon/web";
import ACIcon from "shared-components/Components/CustomIcons/ACICon/web";
import WifiIcon from "shared-components/Components/CustomIcons/WifiIcon/web";
import "./styles.less";

export const FacilitiesCard = ({ facilities, dataFormat = "object" }: { facilities: any[], dataFormat?: "object" | "idsArray" }) => {
  const ids = facilities?.map((facility) => dataFormat == 'idsArray' ? facility : facility.id);

  const amenities = [
    {
      title: "Parrillero",
      icon: <GrillIcon width={25} />,
      has: ids.includes("13"),
    },
    {
      title: "Aire Acondicionado",
      icon: <ACIcon width={23} />,
      has: ids.includes("36"),
    },
    {
      title: "Piscina",
      icon: <PoolIcon width={23} />,
      has: ids.includes("27"),
    },
    {
      title: "Wifi",
      icon: <WifiIcon width={23} />,
      has: ids.includes("31"),
    }
  ];

  return (
    <div className="amenities-container">
      {amenities.map(({ has, icon, title }, i) => (
        <Tooltip title={has ? title : ""} color="black" key={`tooltip-${i}`}>
          <div className={has ? "active" : ""}>{icon}</div>
        </Tooltip>
      ))}
    </div>
  )
}